module.exports = __webpack_public_path__ + "static/media/Emergency Message Transmission Assistance.7d31d45e.png";